<template lang="pug">
  v-row(no-gutters class="mb-1")
    v-flex(xs12 class="d-flex align-center")
      Logo
      v-spacer
      div(v-if="isAuthenticated")
        v-btn(color="#00B341", @click.prevent="addNewAdvert", dark).mr-2
          v-icon(small) add
          span {{ $t('button.advert.new') }}
      div(v-else)
        v-btn(color="#ff5964" dark to="/login" class="mr-5") Создать #[span(class="text-lowercase ml-1") объявление]
        v-btn(color="#0091FF" dark to="/login" class="mr-1") Войти
      SelectLanguage
      Profile(v-if="isAuthenticated", :userRole="userRole")
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'HeaderTop',
  components: {
    Logo: () => import('@/components/Header/Logo.vue'),
    SelectLanguage: () => import('@/components/Header/SelectLanguage'),
    Profile: () => import('@/components/Header/Profile')
  },
  created() {
    if (this.isAuthenticated) {
      this.$store.dispatch('GET_USER_INFO')
    }
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'isAdmin']),
    ...mapState({
      userRole: state => state.userInfo.role
    })
  },
  methods: {
    addNewAdvert() {
      this.$router.push({ path: '/advert/item/add' })
    }
  }
}
</script>
